import { FillInTheBlanks } from '@lyearn/icons';
import { QuestionTypeEnum } from '@/types/schema';

import { QuizViewField } from '../../../types';
import { getQuestionEvaluation } from '../../../utils';
import FtbPlayer from '../../FtbPlayer';
import QuestionReview from '../../QuestionReview';
import { isValidFtbSubmission } from '../../utils';

const FillInTheBlanksViewField: QuizViewField = {
  getQuestionEvaluation,
  isValidSubmission: isValidFtbSubmission,
  Player: FtbPlayer,
  type: QuestionTypeEnum.FillInTheBlanks,
  getQuestionLabel: () => 'QuizPlayer:QuestionType.FillInTheBlanks',
  labelKey: 'QuizPlayer:QuestionType.FillInTheBlanks',
  Icon: FillInTheBlanks,
  Review: QuestionReview,
};

export default FillInTheBlanksViewField;
